//Create function that compares two strings, case insensitive
export function compareStrings(a:string, b:string) {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();

    return (a < b) ? -1 : (a > b) ? 1 : 0;
}